(() => {
  let session, pending;
  const root=window.Shopify?.routes?.root||'/';
  async function get(fresh=false){
    if(pending)return pending;
    if(session&&!fresh)return session;
    pending=(async()=>{
      const response=await fetch(root+'apps/wyper-shopper/session',{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(30000)});
      if(!response.ok)throw new Error('No se ha podido comprobar tu sesión. Inténtalo de nuevo.');
      const next=await response.json();
      if(typeof next.loggedIn!=='boolean')throw new Error('La sesión no está disponible.');
      session=next;return {...session};
    })();
    try{return await pending;}finally{pending=null;}
  }
  window.WyperSession={get};
})();

